const badgetypes = [
    'AAA',
    'IND',
    'INB',
    'OND'
];
export default badgetypes